export default {
  meta: {
    title: 'AI陪练配置',
    parentPath: 'BOT配置',
    breadcrumbs: ['BOT配置', 'AI陪练配置'],
  },
};
